export const HOMEPAGE_BANNER_CLICKED = 'Homepage Banner Clicked'
export const HOMEPAGE_BANNER_VIEWED = 'Homepage Banner Viewed'
export const MAX_WIDTH = 1240

// guest home
export const SET_GUEST_BANNERS_HEIGHT = 'SET_GUEST_BANNERS_HEIGHT'
export const MAX_GUEST_HEIGHT = 495

//signed home
export const SET_SIGNED_BANNERS = 'SET_SIGNED_BANNERS'
export const SET_SIGNED_BANNERS_META = 'SET_SIGNED_BANNERS_META'

//brands home
export const SET_BRANDS_BANNERS = 'SET_BRANDS_BANNERS'
export const SET_BRANDS_BANNERS_HEIGHT = 'SET_BRANDS_BANNERS_HEIGHT'
export const MAX_BRANDS_HEIGHT = 205
export const SET_BRANDS_STORE = 'SET_BRANDS_STORE'

//home events
export const SET_BRANDS_BANNERS_VISIBILITY = 'SET_BRANDS_BANNERS_VISIBILITY'
